import { useRouteModal } from '../../route-modals/hooks/useRouteModal'
import { EModalType } from '../../route-modals/types/modalTypes'

export type UseLiveEventTypeModalHookParams = {
  eventTypeId: string
  trackedGameId: string
  tab?: string
  eventId?: string
}

export const useLiveEventTypeModal = () => {
  const { pushModal } = useRouteModal()
  const showLiveEventTypeModal = ({ trackedGameId, eventTypeId, tab, eventId }: UseLiveEventTypeModalHookParams) => {
    pushModal({
      type: EModalType.LIVE_EVENT_TYPE,
      params: {
        trackedGameId,
        liveEventTypeId: eventTypeId,
        tab,
        liveEventId: eventId,
      },
    })
  }

  return {
    showModal: showLiveEventTypeModal,
  }
}
